export const userDataDefaultValue = {
    "editor": {
        "id": 0,
        "employeeId": 0,
        "name": "",
        "username": "",
    },
    "status": {
        "all": {
            "total": 0,
            "dormant": 0,
            "expired": 0,
            "in-review": 0,
            "released": 0,
            "successful": 0,
        },
        "editor": {
            "total": 0,
            "myTasks": 0,
            "queuedTasks": 0,
        }
    },
    "endpoints": {
        "fetchApplications": "",
        "fetchQueuedTasks": "",
        "fetchMyTasks": "",
        "fetchAssignedToMe": ""
    },
    "explanations": [],
    // "translations": {},
    "errorUser": { error: false, message: ""},
    "setErrorUser": () => {}, "setUserData": ()  => {}
}
export const oauthDataDefaultValue = {
    doRefreshToken: () => {
    },
    doLogout: () => {
    },
    client: {},
    token: {},
    authToken: "",
    phase: "",
    config: {},
    getJwtData: () => {},
    isTokenExpired: () => {}
}